import gql from "graphql-tag";
import BlogPostPreviewFragment from "../fragments/blogPostPreviewFragment";

const blogPostsQuery = gql`
    query BlogPostsQuery(
        $topics: [String]
        $universityId: String
        $universitySlug: String
        $degreeId: String
        $authorId: String
        $limit: LimitedInt
    ) {
        allPosts(
            topics: $topics
            universityId: $universityId
            universitySlug: $universitySlug
            degreeId: $degreeId
            authorId: $authorId
            safeLimit: $limit
        ) {
            ...BlogPostPreviewFragment
        }
    }

    ${BlogPostPreviewFragment}
`;

export default blogPostsQuery;
